import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";

export function Screen({
  title,
  subtitle,
  showBack,
  children,
}: {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <div className="screen">
      {showBack && (
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Назад
        </button>
      )}
      <h1 className="screen-title">{title}</h1>
      {subtitle && <p className="screen-subtitle">{subtitle}</p>}
      {children}
    </div>
  );
}
